import posed from 'react-pose'
import styled from 'styled-components/macro'
const AnimatedContainer = posed.div({
  visible: {
    opacity: 1,
    y: 0,
    transition: ({ delay = 0 }) => ({
      type: 'spring',
      stiffness: 150,
      damping: 15,
      delay: 200 + delay
    })
  },

  hidden: {
    opacity: 0,
    y: 100
  }
})

const AnimatedContainerTop = styled(
  posed.div({
    visible: {
      opacity: 1,
      y: 0,
      transition: ({ delay = 0 }) => ({
        type: 'spring',
        stiffness: 150,
        damping: 15,
        delay: 200 + delay
      })
    },

    hidden: {
      opacity: 0,
      y: -100
    }
  })
)`
  z-index: 100;
  position: sticky;
  top: 0;
`

export { AnimatedContainerTop, AnimatedContainer }
